import { render } from "./IreInvestmentAreasListing.vue?vue&type=template&id=1b48036f&ts=true"
import script from "./IreInvestmentAreasListing.vue?vue&type=script&lang=ts"
export * from "./IreInvestmentAreasListing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__